<div class="container">
  <div class="header-row">
    <div class="title-row">
      <h2 class="section-title">MANAGE NOTIFICATIONS</h2>
      @if (isLoading) {
        <span class="loading-label">Loading...</span>
      }
    </div>
    @if (canManage$ | async) {
      <button mat-fab extended class="warn" (click)="openAddNewModal()">
        <mat-icon>add</mat-icon>
        ADD NEW
      </button>
    }
  </div>

  <div class="content">
    <ag-grid-angular
      style="width: 100%; height: 65vh"
      [columnDefs]="colDefs"
      [defaultColDef]="defaultColDef"
      [suppressCellFocus]="true"
      (gridReady)="onGridReady($event)"
      [theme]="theme"
      [gridOptions]="gridOptions"
      (cellClicked)="onCellClicked($event)"
    />
  </div>

  <div class="footer-row">
    <mat-checkbox
      [checked]="showInactive"
      (change)="onShowInactiveChange($event.checked)"
      color="primary"
    >
      Show Inactive
    </mat-checkbox>
  </div>
</div>
